import React from "react";
import Anamnese from "../components/anamnese/Anamnese";
import { useAuthenticator } from '@aws-amplify/ui-react';
import { verifiedUser } from '../components/utils';
import { Container } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';

const AnamneseEntry = (props) => {
  const { user } = useAuthenticator((context) => [context.user]);
  const massnid = user ? user.attributes['custom:kvsID'] : undefined;
  // console.log(user)

  if (!verifiedUser(user)) {
    return (<Navigate to='/profile' replace={true} />)
  }

  return (
    <Container fluid >
      <Anamnese authenticated={user} massnid={massnid} readOnly={false} />
    </Container>
  )

}

export default AnamneseEntry